import { Tag, TagLabel } from "~/react/ui/tag"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"
import { format } from "date-fns"

const sourceClasses = cva("ds-sources-list__item", {
  variants: {
    outdated: {
      true: "ds-sources-list__item--outdated",
    },
  },
})

export interface SourceType {
  domain: string
  link: string
  extracted_on: Date
  last_seen_on: Date
  still_on_page: boolean
  email_on_page: boolean
}

const SourceTag = ({ source }: { source: SourceType }) => {
  if (source.still_on_page) {
    const label = source.email_on_page
      ? i18n.t("js.multi_domain_search.result.source.email")
      : i18n.t("js.multi_domain_search.result.source.mention")

    return (
      <Tag size="sm" variant={"info"}>
        <TagLabel>{label}</TagLabel>
      </Tag>
    )
  }

  return (
    <Tag size="sm">
      <TagLabel>{i18n.t("js.multi_domain_search.result.source.removed")}</TagLabel>
    </Tag>
  )
}

export const Source = ({ source }: { source: SourceType }) => {
  const { link, last_seen_on, still_on_page } = source

  return (
    <li className={cn(sourceClasses({ outdated: !still_on_page }))}>
      <SourceTag source={source} />

      <a className="ds-sources-list__link" href={link} rel="noopener noreferrer nofollow" target="_blank">
        {link}
      </a>
      <time className="ds-sources-list__date">{format(last_seen_on, "MMM d, yyyy")}</time>
    </li>
  )
}
